export const DARK_THEME_CLASS = 'dark-theme'

/**
 * The current value of a `colors.scss` token, for colors that have to be handed to JavaScript (charts,
 * canvas, SVG built in code) rather than set in a stylesheet. Read it when drawing, not once at load,
 * so a chart drawn after the theme changes picks the new value up.
 */
export function themeColor(token: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(`--color-${token}`).trim()
}

/** For code that has to pick between whole palettes, where a single token would not do. Read it when drawing, like `themeColor`. */
export function isDarkTheme() {
  return document.documentElement.classList.contains(DARK_THEME_CLASS)
}
